/**
 * AddCurrencyConverterCtrl controller
 * Add / Edit currency converters
 */

import { CURRENCY_CONVERTER_TYPES } from 'app/core/constants'

/**
 * AddCurrencyConverterCtrl controller
 *
 * @class AddCurrencyConverterCtrl
 * @memberof mwApp/settings
 * @see mwApp/settings
 *
 * @ngdoc controller
 * @name mwApp/settings.controller:AddCurrencyConverterCtrl
 */
/* @ngInject */
export default function AddCurrencyConverterCtrl ($uibModalInstance, converter, alertSvc, authSvc) {
  var vm = this

  /**
   * Has access
   *
   * @memberOf mwApp/settings.controller:AddCurrencyConverterCtrl
   * @function
   */
  vm.hasAccess = function (access) {
    return authSvc.hasAccess(access)
  }

  /**
   * PaymentSystem
   *
   * @memberof mwApp/settings.controller:AddCurrencyConverterCtrl
   * @type {models.CurrencyConverter}
   */
  vm.converter = converter

  /**
   * Is Live rate
   *
   * @memberof mwApp/settings.controller:AddCurrencyConverterCtrl
   * @type {Boolean}
   */
  vm.liveRate = !converter.refreshRateSec

  /**
   * Rate value
   *
   * @memberof mwApp/settings.controller:AddCurrencyConverterCtrl
   * @type {Number}
   */
  vm.rateValue =
    converter.refreshRateSec
      ? (converter.refreshRateSec % 60 === 0
        ? converter.refreshRateSec / 60 // convert minutes to hours
        : converter.refreshRateSec)
      : 1

  /**
   * Rate type
   *
   * @memberof mwApp/settings.controller:AddCurrencyConverterCtrl
   * @type {String}
   */
  vm.rateType =
    converter.refreshRateSec % 60 === 0
      ? 'hours'
      : 'mins'

  /**
   * Payment system types
   *
   * @memberof mwApp/settings.controller:AddCurrencyConverterCtrl
   * @name vm.currency_converter_types
   * @type {Object}
   */
  vm.currency_converter_types = CURRENCY_CONVERTER_TYPES

  /**
   * Create or edit currency converter, and close modal window afterwards
   *
   * @memberof mwApp/settings.controller:AddCurrencyConverterCtrl
   */
  vm.submit = function () {
    vm.setDisable()
    let rateError = false
    if (!vm.liveRate) {
      if (vm.rateType === 'hours' && vm.rateValue > 596523) {
        alertSvc.alert('Your total hours cannot exceed 596 523', 'warning')
        rateError = true
        vm.unsetDisable()
      }
      if (vm.rateType === 'mins' && vm.rateValue > 35791380) {
        alertSvc.alert('Your total minutes cannot exceed 35 791 380', 'warning')
        rateError = true
        vm.unsetDisable()
      }
    }
    // set refresh rate
    converter.refreshRateSec =
      !vm.liveRate
        ? vm.rateValue * (vm.rateType === 'hours' ? 60 : 1)
        : 0

    if (!rateError) {
      converter._save()
        .then(
          () => {
            converter.token = null // emptying token
            $uibModalInstance.close(converter)
          }
        ).finally(vm.unsetDisable)
    }
  }

  /**
   * Cancel editing, close modal window
   *
   * @memberof mwApp/settings.controller:AddCurrencyConverterCtrl
   */
  vm.cancel = function () {
    $uibModalInstance.dismiss('cancel')
  }
}
